export const defaultSorted = [{ dataField: "created_at", order: "desc" }];
export const initialFilter = {
  sortOrder: "desc", // asc||desc
  sortField: "created_at",
  pageNumber: 1,
  pageSize: 20,
  searchKey: "",
};
